import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-206" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-207" data-mp="30j0v1cfg4t69">
        <div className="text-center" data-id="element-208" data-mp="2vpg424c9szgk">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-209" data-mp="2voefqy68uggw">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-white" data-id="element-210" data-mp="35fivw17no7db">
            Sunday at 11 p.m. Tomorrow you have mineral processing class. And you're still searching for the best way
            to explain crushing and grinding, separation methods, flotation circuits, and the role of mineral processing
            in modern extraction without losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-muted" data-id="element-211" data-mp="1k4iuksmwo35a">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-gold/30 bg-steel p-6 shadow-lg shadow-black/20 sm:p-8" data-id="element-212" data-mp="sbp1g5ugn2lv">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-white" data-id="element-213" data-mp="1c227nqnm9nzd">
            <AlertTriangleIcon className="h-5 w-5 text-mineral" aria-hidden="true" data-id="element-214" data-mp="1g3dy1yebed8m" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-215" data-mp="3duqf6c7amxky">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-216" data-mp="3hvip77nzp6ia">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-217" data-mp="p1bp1r4sywqr" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-218" data-mp="y174i85e5dwl">
          <p className="text-lg font-bold text-white" data-id="element-219" data-mp="xyugpecyc9bm">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 text-2xl font-extrabold text-mineral sm:text-3xl" data-id="element-220" data-mp="17xa9rmvjhsnr">
            Plan your entire year today.
          </p>
        </div>
      </div>
    </section>;
}